import React, { Component } from "react";
import * as s from "./CollectionFilter.module.scss";
import { inject, observer } from "mobx-react";
import { FilterStore, UIStore, CollectionStore } from "src/stores";
import {
  NonHierarchicalDropdown,
  DateRangeDropdown,
  HierarchicalDropdown,
  SingleSelectDropdown,
  SelectedTaxonomiesList
} from "src/views/shared/components";
import { Button } from "../Button";
import { tx } from "src/libs/i18n";

interface Props {
  uiStore?: UIStore;
  filterStore?: FilterStore;
  collectionStore?: CollectionStore;
}

@inject("uiStore", "filterStore", "collectionStore")
@observer
export class CollectionFilter extends Component<Props> {
  render() {
    const { uiStore, filterStore, collectionStore } = this.props;
    const { isDesktop } = uiStore;

    const {
      setSortOption,
      sortResultsOptions,
      toggleOption,
      toggleYear,
      prioritize,
      publicationYears,
      authors,
      topics,
      keywords,
      countries,
      publishers,
      contentTypes,
      regions,
      languages,
      resetFilter
    } = filterStore;
    const { applyFilter } = collectionStore;

    return (
      <div className={s.searchFilterColumn}>
        <h3 className={s.filterColTitle}>{tx("filter.refineResults")}</h3>
        <SelectedTaxonomiesList />
        <Button
          size="medium"
          color="red"
          className={s.filterButtons}
          onClick={() => applyFilter()}
        >
          {tx("filter.applyFilter")}
        </Button>
        <Button
          size="medium"
          color="red"
          className={s.filterButtons}
          onClick={() => {
            resetFilter();
            applyFilter();
          }}
        >
          {tx("filter.resetFilter")}
        </Button>
        {!isDesktop && (
          <div className={s.sortResultsDropdownContainer}>
            <SingleSelectDropdown
              options={sortResultsOptions}
              toggleOption={setSortOption}
              label={tx("filter.sortBy")}
            />
          </div>
        )}
        {/* <div className={[s.dropdownContainer, s.noBorder].join(" ")}>
          <NonHierarchicalDropdown
            dropdownTitle={tx("filter.prioritize")}
            largeOptions
            options={prioritize}
            toggleOption={toggleOption}
            className={s.filterDropdown}
            key={"nonHierarchicalDropdown-prioritize"}
          />
        </div> */}
        <div className={s.dropdownContainer}>
          <DateRangeDropdown
            dropdownTitle={tx("filter.publicationYears")}
            toggleYear={toggleYear}
            selectedOptions={publicationYears}
          />
        </div>
        {topics && topics.length > 0 && (
          <div className={s.dropdownContainer}>
            <HierarchicalDropdown
              dropdownTitle={tx("filter.topics")}
              options={topics}
              toggleOption={toggleOption}
              className={s.filterDropdown}
            />
          </div>
        )}
        {authors && authors.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.authors")}
              options={authors}
              toggleOption={toggleOption}
              className={s.filterDropdown}
            />
          </div>
        )}
        {publishers && publishers.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.publishers")}
              options={publishers}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              key={"nonHierarchicalDropdown-publisher"}
            />
          </div>
        )}
        {contentTypes && contentTypes.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.contentType")}
              options={contentTypes}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              key={"nonHierarchicalDropdown-contentType"}
            />
          </div>
        )}
        {countries && countries.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.country")}
              options={countries}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              key={"nonHierarchicalDropdown-country"}
            />
          </div>
        )}
        {regions && regions.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.region")}
              options={regions}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              key={"nonHierarchicalDropdown-region"}
            />
          </div>
        )}
        {languages && languages.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.language")}
              options={languages}
              toggleOption={toggleOption}
              className={s.filterDropdown}
            />
          </div>
        )}
        {/* {mediaFormats && mediaFormats.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle="Media Format"
              options={mediaFormats}
              toggleOption={toggleOption}
              className={s.filterDropdown}
            />
          </div>
        )} */}
        {keywords && keywords.length > 0 && (
          <div className={s.dropdownContainer}>
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.keywords")}
              options={keywords}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              key={"nonHierarchicalDropdown-keywords"}
            />
          </div>
        )}
      </div>
    );
  }
}
